<template>
<div>
    <v-text-field v-model="textValue" @dblclick="menuVisible = !menuVisible" @change="setTextValue" :label="label" ref="textbox" xxxv-on="on" append-icon="today" @click:append="calendarClicked" hide-details/> 
   
    <v-menu offset-y right :nudge-top="-3" v-model="menuVisible" :close-on-content-click="false" >
        <template v-slot:activator="{ on }">
        <div class="full-width" v-on="on"></div>
        </template>
        <div style="display:flex;flex-wrap:wrap;height:300px;background-color:white;padding:7px;">
                
                <v-date-picker class="elevation-0" style="margin:auto" no-title v-model="calendarValue"/>

                
                <div v-if="!dateOnly" class="" style="background-color:white;height:100%;overflow-y:scroll;flex-grow:1;color:#444">
                    <div v-for="n in 25" @click="setTime(getTimeHalfHourly(n))" class="ma-1 time-hoverable clickable time" :class="{'blue-hilight': isSelected(n)}" :key="n">
                        {{getTimeHalfHourly(n)}}
                    </div>
                </div>
                <div v-if="!past" style="background-color:white;height:100%;overflow-y:scroll;flex-grow:1;color:#444">
                    <div @click="clearDate" class="ma-1 shortcut time-hoverable clickable">
                        Clear
                    </div>
                    <div @click="setDays(0)" class="ma-1 shortcut time-hoverable clickable">
                        Today
                    </div>
                    <div @click="setDays(1)" class="ma-1 shortcut time-hoverable clickable">
                        Tomorrow
                    </div>
                    <div @click="setDays(3)" class="ma-1 shortcut time-hoverable clickable">
                        3 Days
                    </div>                        
                    <div @click="setDays(7)" class="ma-1 shortcut time-hoverable clickable">
                        1 Week
                    </div>                        
                    <div @click="setDays(14)" class="ma-1 shortcut time-hoverable clickable">
                        2 Weeks
                    </div>                        
                    <div @click="setDays(21)" class="ma-1 shortcut time-hoverable clickable">
                        3 Weeks
                    </div>                        
                    <div @click="setDays(30)" class="ma-1 shortcut time-hoverable clickable">
                        1 Month
                    </div>                        
                </div>                    
                <div v-if="past" class="" style="background-color:white;height:100%;overflow-y:scroll;flex-grow:1;color:#444">
                    <div @click="clearDate" class="ma-1 shortcut time-hoverable clickable">
                        Clear
                    </div>
                    <div @click="setDays(-1)" class="ma-1 shortcut time-hoverable clickable">
                        Yesterday
                    </div>
                    <div @click="setDays(-2)" class="ma-1 shortcut time-hoverable clickable">
                        2 Days Ago
                    </div>
                    <div @click="setDays(-3)" class="ma-1 shortcut time-hoverable clickable">
                        3 Days Ago
                    </div>                        
                    <div @click="setDays(-7)" class="ma-1 shortcut time-hoverable clickable">
                        1 Week Ago
                    </div>                        
                    <div @click="setDays(-14)" class="ma-1 shortcut time-hoverable clickable">
                        2 Weeks Ago
                    </div>                                              
                    <div @click="setDays(-30)" class="ma-1 shortcut time-hoverable clickable">
                        1 Month Ago
                    </div>                        
                </div>                    
        </div>
    </v-menu>

</div>
</template>

<script>
import DateHelpers from '../helpers/DateHelpers'
import {addDays, format, parse} from 'date-fns'
import Utilities from '../helpers/Utilities'
import { dateFormats } from '../helpers/DateHelpers'

export default {
    data() {
        return {
            storageFormat: dateFormats.BACKWARDS,
            displayFormat: dateFormats.AUSTRALIAN,
            menuVisible: false,
        }
    },

    components: {
        
    },
    
    props: {
        value: String,
        label: String,
        dateOnly: {
            default: false,
            type: Boolean
        },
        past: Boolean,
        short: Boolean,
    },

    computed: {

        datePart() {
            if(!this.value)
                return ''
            return this.value.split(' ')[0].trim()         
        },

        datePartAu() {
            if(!this.datePart)
                return ''
            return DateHelpers.convertDate(this.datePart, this.storageFormat, this.displayFormat)
        },

        timePart() {
            if(!this.value || this.value.length < 2)
                return ''

            let arr = this.value.split(' ')
            if(arr.length < 2)
                return ''
                
            return arr[1].trim()         
        },

        textValue: {
            get: function () {
                if(!this.datePartAu)
                    return ''

                return this.datePartAu + (this.timePart ? ' @ ': '') + this.timePart
            },
            set: function (textValue) {
                //see setTextValue running on change only
            }
        },

        calendarValue: {
            get: function () {
                return this.datePart
            },
            set: function (newValue) {
                this.setDate(newValue)
            }
        },

        availableTimes() {
            return ['7:00 am', '7:30 am', '8:00 am', '8:30 am', '9:00 am', '9:30 am', '10:00 am', '10:30 am', '11:00 am', '11:30 am', '12:00 pm', '12:30 pm', '1:00 pm', '1:30 pm', '2:00 pm', '2:30 pm', '3:00 pm', '3:30 pm', '4:00 pm', '4:30 pm', '5:00 pm', '5:30 pm', '6:00 pm', '6:30 pm', '7:00 pm' ]
        },
    },

    methods: {
        emitChanges(newValue) {
            this.$emit('input', newValue)
            this.$emit('change', newValue)
        },

        clearDate() {
            this.emitChanges(null)
            this.menuVisible = false
        },
        setDays(n) {
            let dateObj = new Date()
            let newDate = DateHelpers.smartDaysFromNow(n)
            this.setDate(format(newDate, this.storageFormat))
        },
        setTextValue(textValue) {
            if(!textValue) {
                this.emitChanges(null)
                return
            }

            let dateStr
            let timeStr
        
            let arr = textValue.split('@')
            
            dateStr = arr[0].trim()

            if(arr.length > 1) {
                timeStr = arr[1].trim()
            }

            let finalDate = DateHelpers.findTimeframeInString(dateStr).date
            
            if(!finalDate)
                finalDate = DateHelpers.toDate(dateStr)
            if(!finalDate) {
                console.error('invalid date')
                return
            }

            let finalFormat = format(finalDate, this.storageFormat)

            let newValue = finalFormat + (timeStr ?  ' ' + timeStr : '')
            this.emitChanges(newValue)
        },

        setDate(newDate) {
            let newValue
            if(!this.value)
                newValue = newDate
            else
                newValue = this.value.replace(this.datePart, newDate) 
            
            this.emitChanges(newValue)
            if(this.dateOnly)
                this.menuVisible = false
        },

        setTime(timeString) {
            timeString = timeString.toLowerCase().replace(' ' , '')
            let date = this.datePart
            if(!date)
                date = DateHelpers.todayString()
            
            let newValue = date + ' ' + timeString
            this.emitChanges(newValue)
            this.menuVisible = false
        },

 
        calendarClicked() {
            this.menuVisible = !this.menuVisible
        },
        getTimeHalfHourly(n) {
            return this.availableTimes[n -1]
        },

        isSelected(n) {
            let time = this.getTimeHalfHourly(n).replace(' ', '')
            return (time == this.timePart)
        },

        isTime(timeString) {
            if(!timeString)
                return false
            
            timeString = timeString.toLowerCase().trim()
            let arr = timeString.split(':')
            if(arr.length != 2)
                return false

            let hrs = parseInt(arr[0])
            let mins = parseInt(arr[1])
            if(hrs == 0 || hrs > 12)
                return false
            if(mins > 59)
                return false

            return true
        },

        windowResized() {
            let componentWidth = this.$el.offsetWidth
            if(componentWidth > 310 && !this.short) 
                this.displayFormat = 'eeee do MMMM'
            else
                this.displayFormat = 'dd/MM/yy'
        },

        debouncedWindowResized: Utilities.debounce( function(event, vm) {  
            vm.windowResized()          
        }, 1000)

    },
    mounted() {
        this.windowResized()
    },
    created() {
        window.addEventListener('resize', this.debouncedWindowResized.bind(null, event, this))

    },
    destroyed() {   
        window.removeEventListener('resize', this.debouncedWindowResized)
    }
}
</script>

<style scoped>
.time {
    padding: 4px 14px;background-color:#eee;border: solid 1px #ddd;border-radius:4px;text-align:right;
}
.shortcut {
    text-align:center;padding: 4px 14px;background-color:white;color:#999;border: solid 1px #ddd;border-radius:4px;
}
.time-hoverable:hover {
    background-color: #dfdfdf;
}

</style>




// WEBPACK FOOTER //
// DateTime.vue?4ea6c816